import { responsiveFontSizes } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

export default function generateMuiTheme(type, primary, secondary) {
  return responsiveFontSizes(
    createTheme({
      typography: {
        fontFamily: 'Nexa Extra Light',
      },
      palette: {
        type: "dark",
        text: { primary: "#fff", secondary: "#9fa0a7" },
        success: { main: "#4aa96c" },
        error: { main: "#D32F2F" },
        divider: "#3B3A48",
        background: {
          default: "#000029",
          paper: "#000029",
        },
        primary: {
          main: "#1178F8",
        },
        darkTheme: {
          one: "#FFFFFF",
          two: "#EFEFEF",
          three: "#DADADA",
          four: "#818181",
          five: "#6F767E",
          six: "#404B53",
          seven: "#232830", //"#26282C", //"#2B3034",
          slightLighter: "#1A1C22",
          main: "#050A0E",
          eight: "#26282C",
          contrastText: "#95959E",
        },
        lightTheme: {
          one: "#FFFFFF",
          two: "#EFEFEF",
          three: "#DADADA",
          four: "#818181",
          five: "#6F767E",
          six: "#404B53",
          seven: "#232830", //"#26282C", //"#2B3034",
          slightLighter: "#1A1C22",
          main: "#050A0E",
          eight: "#26282C",
          contrastText: "#95959E",
        },
        secondary: {
          main: "#000",
          contrastText: "#fff",
        },
        common: { white: "#fff", black: "#000", sidePanel: "#3D3C4E" },
      },
      overrides: {
        MuiTypography: {
          root: { color: "#fff" },
        },
        MuiTooltip: {
          tooltip: {
            fontSize: "1.2vh",
            color: "#fff",
            backgroundColor: "#000",
            padding: "0.6vh 1vh",
            borderRadius: "0.4vh",
          },
        },
      },
    })
  );
}
